import { consultationAmountIcon, gstIcon, lawyerFees, penaltyIcon, refundIcon, revenueIcon } from "../../../../assets/images";
import { PdfHeader } from "../../../../components";
import { rupeeSymbol } from "../../../../utils/appUtils";
import { UserOutlined, PauseCircleOutlined, ClockCircleOutlined, TeamOutlined, ThunderboltOutlined, StopOutlined, CheckCircleOutlined, ExclamationCircleOutlined, SyncOutlined, CloseCircleFilled, CameraFilled, AuditOutlined } from "@ant-design/icons";
import BarChart from "../charts/BarChart";
import { complaintChartDetails, consultationChartDetails, supportChartDetails } from "../config";
import DoughnutChart from "../charts/DoughnutChart";
import "./style.scss";

const DashbordReport = ({
    data,
    fromDate,
    toDate,
    year,
    selectedMonth
}) => {
    const parseCountValue = (...possibleValues) => {
        const validCount = possibleValues?.find((value) => Number?.isFinite(Number(value)));
        return validCount ? Number(validCount) : 0;
    };

    const adminStatsData = [
        { label: "Total Advocates", value: parseCountValue(data?.adminLawyerDetails?.lawyerCount, data?.totalLawyers, data?.totalAdvocates, data?.totalLawyer, data?.totalAdvocate), icon: <UserOutlined className="dashboard-stat-icon" /> },
        { label: "Active Advocates", value: parseCountValue(data?.adminLawyerDetails?.activeLawyers, data?.activeLawyers), icon: <UserOutlined className="dashboard-stat-icon" /> },
        { label: "Advocates On-hold", value: parseCountValue(data?.adminLawyerDetails?.lawyersOnHold, data?.holdLawyers), icon: <PauseCircleOutlined className="dashboard-stat-icon" /> },
        { label: "Not Approved Advocates", value: parseCountValue(data?.adminLawyerDetails?.pendingLawyers, data?.pendingLawyers), icon: <ExclamationCircleOutlined className="dashboard-stat-icon" /> },
        { label: "Partially Updated Advocates", value: parseCountValue(data?.adminLawyerDetails?.partialUpdateLawyers, data?.partialUpdateLawyers), icon: <SyncOutlined className="dashboard-stat-icon" /> },
        { label: "Penalty Pending Advocates", value: parseCountValue(data?.adminLawyerDetails?.penaltyPending, data?.pendingLawyers, data?.pendingAdvocates, data?.totalPendingLawyers, data?.totalPendingAdvocates), icon: <ClockCircleOutlined className="dashboard-stat-icon" /> },
        { label: "Rejected Advocates", value: parseCountValue(data?.adminLawyerDetails?.rejectedLawyers, data?.rejectedLawyers), icon: <StopOutlined className="dashboard-stat-icon" /> },
        { label: "Instantly Available Advocates (Today)", value: parseCountValue(data?.adminLawyerDetails?.instantlyAvailableLawyers, data?.instantAvailableLawyers, data?.instantAvailableAdvocates, data?.instantAvailableAdvocate, data?.instantAvailableLawyer), icon: <ThunderboltOutlined className="dashboard-stat-icon" /> },
        { label: "Advocates Availability Count", value: parseCountValue(data?.adminLawyerDetails?.lawyerAvailabilityCount, data?.advocateAvailabilityCount, data?.lawyerAvailabilityCount, data?.availableLawyersCount, data?.availableLawyers, data?.lawyerAvailability), icon: <CheckCircleOutlined className="dashboard-stat-icon" /> },
        { label: "Total Clients", value: parseCountValue(data?.adminCustomerDetails?.customerCount, data?.totalCustomers, data?.totalCustomer), icon: <TeamOutlined className="dashboard-stat-icon" /> },
        { label: "Active Client", value: parseCountValue(data?.adminCustomerDetails?.activeCustomerCount, data?.activeCustomers), icon: <TeamOutlined className="dashboard-stat-icon" /> },
        { label: "Hold Client", value: parseCountValue(data?.adminCustomerDetails?.holdCustomerCount, data?.holdCustomers, data?.holdCustomer, data?.totalHoldCustomers, data?.totalHoldCustomer), icon: <PauseCircleOutlined className="dashboard-stat-icon" /> },
    ];

    const overviewMetrics = [
        { label: "Cons. Amount", value: data?.totalConsultationAmount, icon: <img src={consultationAmountIcon} alt="" /> },
        { label: "Revenue", value: data?.totalRevenue, icon: <img src={revenueIcon} alt="" /> },
        { label: "Refund Amount", value: data?.totalRefundAmount, icon: <img src={refundIcon} alt="" /> },
        { label: "Advocate Fees", value: data?.totalLawyerFee, icon: <img src={lawyerFees} alt="" /> },
        { label: "Penalty Amount", value: data?.totalPenaltyAmount, icon: <img src={penaltyIcon} alt="" /> },
        { label: "Auto-Cancl. Amt.", value: data?.totalAutocancelAmount, icon: <CloseCircleFilled style={{ fontSize: 18, color: "#767676" }} /> },
        { label: "Recording Session Amt.", value: data?.totalRecordAmount, icon: <CameraFilled style={{ fontSize: 18, color: "#767676" }} /> },
        { label: "GST Amount", value: data?.totalConsultationGstAmount, icon: <img src={gstIcon} alt="" /> },
        { label: "TDS Amount", value: data?.tdsAmount ?? data?.totalTdsAmount, icon: <AuditOutlined style={{ fontSize: 18, color: "#767676" }} /> },
    ];

    return <div className="dashboard-report">
        <PdfHeader pdfName={"OverAll Overview"} fromDate={fromDate} toDate={toDate} year={year} selectedMonth={selectedMonth}/>
        <div style={{ backgroundColor: "#F6F6F6", padding: "10px", margin: "10px", borderRadius: "10px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(5, minmax(0, 1fr))", gap: "10px 12px" }}>
                {
                    overviewMetrics?.map((metric) => (
                        <div key={metric?.label}>
                            <div className="d-flex justify-content-left gap-2 align-items-center">
                                {metric?.icon}
                                <p className="overview-info">{metric?.label}</p>
                            </div>
                            <div>
                                <h6 className="overview-amount">
                                    {rupeeSymbol} {Number(metric?.value ?? 0)?.toLocaleString("en-IN")}
                                </h6>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
        <div style={{ padding: "0px 10px 10px 10px" }}>
            <h6>Admin Stats</h6>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(5, minmax(0, 1fr))", gap: "8px" }}>
                {
                    adminStatsData?.map((statItem) => (
                        <div key={statItem?.label} style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "8px", backgroundColor: "#FFFFFF" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                {statItem?.icon}
                                <p style={{ margin: 0, fontSize: "11px", lineHeight: 1.2 }}>{statItem?.label}</p>
                            </div>
                            <h6 style={{ margin: "6px 0 0 0", fontSize: "14px" }}>{statItem?.value?.toLocaleString("en-IN")}</h6>
                        </div>
                    ))
                }
            </div>
        </div>
        <div style={{padding:"0px 10px"}}>
            <h6>Consultation</h6>
            <div style={{ width: "100%", height: 150 }}>
                <BarChart configData={consultationChartDetails} data={consultationChartDetails?.map((detail) => data?.[detail?.key])} horizontal={true} animation={false} />
            </div>
        </div>
        <div>
            <div className="flexible" style={{height:250}}>
                <div style={{padding:"0px 10px"}}>
                    <h6>Complaints</h6>
                    <div>
                        <DoughnutChart configData={complaintChartDetails} data={complaintChartDetails?.map((detail) => data?.[detail?.key])} animation={false} />
                    </div>
                </div>
                <div style={{padding:"0px 10px"}}>
                    <h6>Support</h6>
                    <div>
                        <DoughnutChart configData={supportChartDetails} data={supportChartDetails?.map((detail)=>data?.[detail?.key])} animation={false} />
                    </div>
                </div>
            </div>
        </div>
    </div>
};
export default DashbordReport